import { render, staticRenderFns } from "./SalesData.vue?vue&type=template&id=db9bd5ee&scoped=true&"
import script from "./SalesData.vue?vue&type=script&lang=js&"
export * from "./SalesData.vue?vue&type=script&lang=js&"
import style0 from "./SalesData.vue?vue&type=style&index=0&id=db9bd5ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9bd5ee",
  null
  
)

export default component.exports